import FormCRUD from 'mrf/view/FormCRUD';
import { Grid, Col } from 'mrf/view/Grid';
import TextField from 'mrf/view/TextField';
import React from 'react';
import { useFormSelector } from 'mrf/redux/ReduxHelper';

export default function ChangePassword({ history, match }) {
    const context = useFormSelector({
        id: match.params.id,
        resource: 'passwords',
        endpoint: '/api/Users/changePassword'
    });

    return (
        <div className='max-w-screen-sm mx-auto mt-5'>
            <FormCRUD
                title='Change Password'
                match={match}
                history={history}
                context={context}
            >
                <Grid>
                    <Col size={12}>
                        <TextField
                            type='password'
                            label='Old Password'
                            field='oldPassword'
                        />
                    </Col>
                    <Col size={12}>
                        <TextField
                            type='password'
                            label='New Password'
                            field='newPassword'
                        />
                    </Col>
                    <Col size={12}>
                        <TextField
                            type='password'
                            label='Confirm Password'
                            field='confirmPassword'
                        />
                    </Col>
                </Grid>
            </FormCRUD>
        </div>
    );
}